import React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import Axios from "axios";

import { routes } from "./routes";

import "@styles";

Axios.defaults.baseURL = import.meta.env.VITE_API_URL;

// A data router is required: `useAnalyticsGtm` uses `useMatches`, and the unsaved-changes guard
// (`useNavigationBlocker`) uses `useBlocker`.
const router = createBrowserRouter(routes);

const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
